/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weekNumber: NonNullable<unknown> }} Week_Session_Calendar_Week_TitleInputs */

const fr_week_session_calendar_week_title = /** @type {(inputs: Week_Session_Calendar_Week_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.weekNumber}`)
};

/**

* @param {Week_Session_Calendar_Week_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_calendar_week_title = /** @type {((inputs: Week_Session_Calendar_Week_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Calendar_Week_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_calendar_week_title(inputs)
});